export default function useNextLesson(
  videoConfig,
  router,
  removeTimer,
  cancel
) {
  const nextLesson = () => {
    const pathname = `${window.location.pathname.replace(/\/academy/g, "")}`;
    const currentLessonName = pathname.split("/").pop();

    // Add null checks for videoConfig and its values
    if (!videoConfig || !Object.values(videoConfig).length) {
      console.error("Video configuration is missing or empty");
      return;
    }

    const currentLesson = Object.values(videoConfig).findIndex(
      (x) => x?.url?.split("/").pop() === currentLessonName
    );

    const nextContainer = document.querySelector(".next-lesson-container");
    const isLearningPath = router.query.learningPathway;
    const searchParams = window.location.search;

    if (cancel) {
      nextContainer && (nextContainer.style.display = "none");
      return;
    }

    nextContainer && (nextContainer.style.display = "block");

    // Add null checks for current and next lesson URLs
    const currentUrl =
      videoConfig[currentLesson]?.url?.replace(/\/academy/g, "") || "";
    const nextLessonUrl =
      videoConfig[currentLesson + 1]?.url?.replace(/\/academy/g, "") || "";

    // Only proceed if we have valid URLs
    if (!currentUrl || !nextLessonUrl) {
      console.error("Invalid lesson URLs");
      nextContainer && (nextContainer.style.display = "none");
      return;
    }

    const nextUrl = isLearningPath
      ? `/learning-paths/${router.query.learningPathway}/${router.query.course}/${nextLessonUrl.split("/").pop()}${searchParams}`
      : nextLessonUrl + searchParams;

    if (removeTimer) {
      window.location.href = `/academy${nextUrl}`;
    } else {
      setTimeout(() => {
        if (nextContainer?.style?.display === "block") {
          window.location.href = `/academy${nextUrl}`;
        }
      }, 3000);
    }
  };

  return nextLesson;
}
